export default function gameOTP(state={}, action) {
	switch (action.type) {
		default:
			break;
	}
	return state;
}


// WEBPACK FOOTER //
// ./app/reducers/gameOTP.js